function Sleep(milliseconds) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}
export {
  Sleep as S
};
//# sourceMappingURL=sleep.js.map
